import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { APIURL } from "../../../Global";
import { useAlert } from "react-alert";

function AddMachine({ show, onHide, machine, onSuccess }) {
    const alert = useAlert();
    const [formData, setFormData] = useState({
        machine_name: "",
        machine_code: "",
        description: ""
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (machine) {
            setFormData({
                machine_name: machine.machine_name || "",
                machine_code: machine.machine_code || "",
                description: machine.description || ""
            });
        } else {
            setFormData({
                machine_name: "",
                machine_code: "",
                description: ""
            });
        }
    }, [machine, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const tokenString = sessionStorage.getItem("usertoken");
        const token = tokenString ? tokenString.replace(/["]+/g, "") : "";

        try {
            let response;
            if (machine) {
                // Edit machine
                response = await axios.put(`${APIURL}/api/v1/staff/machine-view/`, 
                    { ...formData, machine_id: machine.id },
                    { headers: { Authorization: `Token ${token}` } }
                );
            } else {
                // Create machine
                response = await axios.post(`${APIURL}/api/v1/staff/machine-view/`, 
                    formData,
                    { headers: { Authorization: `Token ${token}` } }
                );
            }

            if (response.data.status === "success") {
                alert.success(machine ? "Machine updated successfully" : "Machine created successfully");
                onSuccess();
                onHide();
            } else {
                alert.error(response.data.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error saving machine:", error);
            alert.error("Error communicating with server");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{machine ? "Edit Machine" : "Add New Machine"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form id="machine-form" onSubmit={handleSubmit}>
                    <div className="machine-form-group">
                        <label>Machine Name</label>
                        <input
                            type="text"
                            name="machine_name"
                            className="machine-form-control"
                            value={formData.machine_name}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="machine-form-group">
                        <label>Machine Code</label>
                        <input
                            type="text"
                            name="machine_code"
                            className="machine-form-control"
                            value={formData.machine_code}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="machine-form-group">
                        <label>Description</label>
                        <textarea
                            name="description"
                            className="machine-form-control"
                            rows="3"
                            value={formData.description}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button 
                    variant="primary" 
                    type="submit" 
                    form="machine-form"
                    style={{ backgroundColor: "#55479F", border: "none" }}
                    disabled={loading}
                >
                    {loading ? "Saving..." : machine ? "Update Machine" : "Create Machine"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AddMachine;
